<!-- 表二列表 -->

<template>
  <div class="ListCage Rtable9">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 2-1：音像制品出版情况登记表</span>
      <span v-else>表 2-1：电子出版物出版情况登记表</span>
      <div class="tabBtns">
        <el-button size="mini" @click="goBack">返回</el-button>
        <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
					<el-option v-for="item in options" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select> -->
      </div>
    </div>
    <div class="ctrlsLine">
      <el-radio-group v-model="yearSet" @change="tabSeek">
        <el-radio :label="0">全部</el-radio>
        <el-radio :label="1">{{ this.selYear - 2 }}年</el-radio>
        <el-radio :label="2">{{ this.selYear - 1 }}年</el-radio>
      </el-radio-group>
      <el-input v-model="seekPms.keyword" size="small" placeholder="通过出版物名称、专用书号查询"></el-input>
      <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button>
    </div>
    <div class="table_tips">
      <p>注：此表内容只能从书号系统同步数据，规则为成品上传时间在两个核验年度中的全部出版物信息。</p>
      <!-- <p style="text-indent: 2em">数据录入完成之后，请点击“ISBN验重”按钮，检查是否有ISBN重复的情况。</p>
			<p style="text-indent: 2em">
				书号系统导入的数据为已经成书上传的数据，“是否中小学教材”和“是否中小学教辅”无法通过书号系统获取，默认为“否”。可以手动修改，也可以先导出Excel，修改后再导入Excel。
			</p> -->
    </div>
    <div class="tabArea">
      <el-table
        :data="filterData(tabDat, seekPms).slice((currentPage - 1) * pageSize, currentPage * pageSize)"
        border
        style="width: 100%"
        v-loading="loading">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + pageSize * (seekPms.no - 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="year" label="年份" width="90" align="center"> </el-table-column>
        <el-table-column prop="publicationName" label="出版物名称" width="180" align="center"> </el-table-column>
        <el-table-column prop="isbn" width="150" label="专用书号(ISBN 978-7-)" align="center"> </el-table-column>
        <el-table-column label="载体形式" width="90" align="center">
          <template slot-scope="scope">
            <div v-if="pressType == 1">
              {{ scope.row.carrierForm | translate("C010", dicMap, scope.row) }}
            </div>
            <div v-else-if="pressType == 2">
              {{ scope.row.carrierForm | translate("C025", dicMap, scope.row) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="出版形式" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.publicationForm | translate("C011", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column prop="productionUnit" label="节目来源/制作单位" width="120" align="center"> </el-table-column>
        <el-table-column prop="programCapacity" label="节目时长或容量(分钟/兆)" width="120" align="center">
        </el-table-column>
        <el-table-column prop="publicationQuantity" label="出版数量（张/盒）" width="90" align="center">
        </el-table-column>
        <!-- <el-table-column prop="issueQuantity" label="发行数量（张/盒）" width="90" align="center"> </el-table-column>
        <el-table-column prop="unitPrice" label="发行单价（元）" width="90" align="center"> </el-table-column> -->
        <el-table-column prop="publishingTime" label="出版时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishingTime | stringTrans("time") }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否缴送样本" align="center">
          <template slot-scope="scope">
            {{ scope.row.sampleDelivery | translate("C018", dicMap) }}
          </template>
        </el-table-column> -->
        <el-table-column label="是否书配盘标记" align="center">
          <template slot-scope="scope">
            {{ scope.row.sign | translate("C018", dicMap) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="value !== ''">
        <p v-show="value !== ''">历史版本：</p>
        <el-table :data="historyJsonParams" border style="width: 100%" v-loading="loading">
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + pageSize * (seekPms.no - 1) }}
            </template>
          </el-table-column>
          <el-table-column prop="year" label="年份" width="90" align="center"> </el-table-column>
          <el-table-column prop="publicationName" label="出版物名称" width="180" align="center"> </el-table-column>
          <el-table-column prop="isbn" width="150" label="专用书号(ISBN 978-7-)" align="center"> </el-table-column>
          <el-table-column label="载体形式" width="90" align="center">
            <template slot-scope="scope">
              <div v-if="pressType == 1">
                {{ scope.row.carrierForm | translate("C010", dicMap, scope.row) }}
              </div>
              <div v-else-if="pressType == 2">
                {{ scope.row.carrierForm | translate("C025", dicMap, scope.row) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="出版形式" width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.publicationForm | translate("C011", dicMap) }}
            </template>
          </el-table-column>
          <el-table-column prop="productionUnit" label="节目来源/制作单位" width="90" align="center"> </el-table-column>
          <el-table-column prop="programCapacity" label="节目时长或容量(分钟/兆)" width="90" align="center">
          </el-table-column>
          <el-table-column prop="publicationQuantity" label="出版数量（张/盒）" width="90" align="center">
          </el-table-column>
          <el-table-column prop="issueQuantity" label="发行数量（张/盒）" width="90" align="center"> </el-table-column>
          <el-table-column prop="unitPrice" label="发行单价（元）" width="90" align="center"> </el-table-column>
          <el-table-column prop="publishingTime" label="出版时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.publishingTime | stringTrans("time") }}
            </template>
          </el-table-column>
          <el-table-column label="是否缴送样本" align="center">
            <template slot-scope="scope">
              {{ scope.row.sampleDelivery | translate("C018", dicMap) }}
            </template>
          </el-table-column>
          <el-table-column label="是否书配盘标记" align="center">
            <template slot-scope="scope">
              {{ scope.row.sign | translate("C018", dicMap) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="memberEdit(scope.row)" type="primary">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea newEditArea" :class="value !== '' ? 'newStyle' : ''">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input disabled size="small" v-model="declare.personnel"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input disabled size="small" v-model="declare.contact"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input disabled size="small" v-model="updatedAt"></el-input>
          </div>
        </div>
      </div>
      <div class="editArea newEditArea" :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input
              disabled
              size="small"
              v-model="historyDeclare.personnel"
              :class="historyDeclare.personnel !== declare.personnel ? 'highlight' : ''">
            </el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input
              disabled
              size="small"
              v-model="historyDeclare.contact"
              :class="historyDeclare.contact !== declare.contact ? 'highlight' : ''">
            </el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input
              disabled
              size="small"
              v-model="historyDeclare.updatedAt"
              :class="historyDeclare.updatedAt !== updatedAt ? 'highlight' : ''">
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="pageCage" v-if="pgAll > 1">
      <el-pagination
        @current-change="pageSent"
        :current-page="seekPms.no"
        layout="prev, pager, next"
        :page-count="pgAll">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import initPagin from "@/mixins/initPagin";
import { tabList9, tab9Remove, tab9Clean, pSubmitHistoryList } from "@/api/pressRole/pressRole";
import { getFileToken } from "@/api/account";
export default {
  mixins: [initPagin],
  data() {
    return {
      pressType: this.$route.query.pressType,
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        year: "",
        keyword: "",
        no: 1,
        size: 15,
      },
      pgAll: 0,
      declare: {
        personnel: "",
        contact: "",
      },
      updatedAt: "",
      historyJsonParams: [],
      historyJson: [],
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: "",
      },
      options: [],
      value: "",
      selYear: 0,
    };
  },
  filters: {
    translate: function (dat, code, transMap, rowDat) {
      if (code == "C010" || code == "C025") {
        if (transMap[code][dat] == "其他") {
          return rowDat.carrierFormQT;
        } else {
          return transMap[code][dat];
        }
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function (dat, code) {
      if (dat != null && code == "time") {
        let timeStr = dat.substr(0, 10);
        return timeStr;
      }
      return dat;
    },
  },
  methods: {
    //HYY新加
    tabSeek: function (type) {
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      if (this.yearSet == 0) {
        this.seekPms.year = "";
      } else if (this.yearSet == 1) {
        this.seekPms.year = this.selYear - 2;
      } else if (this.yearSet == 2) {
        this.seekPms.year = this.selYear - 1;
      }
      let vm = this;

      tabList9(this.seekPms).then((response) => {
        vm.tabDat = [];

        let pages = 1;
        if (response.ppublicationList.length > 0) {
          // 近两年的申报 奇数年是1年 偶数年是2年
          let dummyYear = response.ppublicationList[0].year;
          if (dummyYear % 2 == 0) {
            vm.selYear = dummyYear * 1 + 1;
          } else {
            vm.selYear = dummyYear * 1 + 2;
          }
          pages = parseInt(response.ppublicationList.length / vm.pageSize);
          if (response.ppublicationList.length % vm.pageSize > 0) {
            pages += 1;
          }
        }

        setTimeout(function () {
          for (var i = 0; i < response.ppublicationList.length; i++) {
            if (!(response.ppublicationList[i].publicationName == "无" && response.ppublicationList[i].isbn == "无")) {
              vm.tabDat.push(response.ppublicationList[i]);
            }
          }

          vm.loading = false;
          vm.pgAll = pages;
          if (response.pOrganizationPersonnel !== null) {
            vm.declare.contact = response.pOrganizationPersonnel.contact;
            vm.declare.personnel = response.pOrganizationPersonnel.personnel;
            vm.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        }, 300);
      });
    },

    dictInit: function () {
      let nameArr = ["C010", "C011", "C018", "C025"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "map" });
      newPromise.then((result) => {
        this.dicMap = result;
        this.tabSeek();
      });
    },
    memberEdit: function (dat) {
      let pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edsct_tab9",
        query: pathParams,
      });
    },

    pageSent: function (inx) {
      this.seekPms.no = inx;
      // this.tabSeek();
      this.currentPage = inx;
    },

    goBack: function () {
      this.$router.go(-1);
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function () {
      let that = this;
      pSubmitHistoryList({ publishMaterialId: this.$route.query.mtId }).then((response) => {
        that.historyJson = response.pSubmitHistoryList;
        for (const list of response.pSubmitHistoryList) {
          that.options.push({ value: list.createdAt, id: list.id });
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function (id) {
      const that = this;
      for (const list of that.historyJson) {
        if (id == list.id) {
          that.historyJsonParams = JSON.parse(list.afterJson);
          that.historyDeclare = JSON.parse(list.submittor);
        }
      }
      // 获取图片
      getFileToken().then((data) => {
        that.historyImgUrl =
          process.env.BASE_API +
          "/File/File/download/token/" +
          data.resultStatus.token +
          "/id/" +
          that.historyJsonParams.yyzzId;
      });
    },
    filterData: function (data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      let text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      let list = _.filter(data, (x) => {
        // if (params.type !=0 && x.type != params.type) return false
        return (
          ((x.publicationName && x.publicationName.includes(text)) || (x.isbn && x.isbn.includes(text))) &&
          (params.year == 0 || x.year == params.year)
        );
      });

      let pages = parseInt(list.length / this.pageSize);
      if (list.length % this.pageSize > 0) {
        pages += 1;
      }
      this.pgAll = pages;
      if (this.currentPage > this.pgAll) {
        this.seekPms.no = 1;
        this.currentPage = 1;
      }

      return list;
    },
  },
  mounted() {
    this.getHistoryList();
  },
  created: function () {
    if (this.$route.query.pressType == 1) {
      this.selYear = Number(sessionStorage.getItem("selYearYx") || 0);
    } else {
      this.selYear = Number(sessionStorage.getItem("selYearDz") || 0);
    }
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleL";

.table_tips {
  color: red;
  font-size: 14px;
}
.Rtable9 .el-radio + .el-radio {
  margin-left: 20px;
}

.Rtable9 .ctrlsLine .el-input {
  display: inline-block;
  width: 360px;
  margin-left: 20px;
}

.Rtable9 .pageCage {
  padding: 30px 0px;
  text-align: center;
}

.Rtable9 {
  .highlight {
    .el-input__inner,
    .el-textarea__inner {
      color: red !important;
    }
  }

  .newStyle {
    margin: 30px 0 !important;
    width: 50% !important;
    overflow: hidden;
    float: left;
  }

  .selectTime {
    float: left;
    font-weight: normal;
    margin: -5px 30px;
  }

  .editBox {
    overflow: hidden;
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table9.vue?3fdf31b5